var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelcomeModalIllustrationUtilita(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 646,
    height: 320,
    viewBox: "0 0 646 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M646 289.091H0V319.258H646V289.091Z",
    fill: "#0098ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M300.825 227.115C300.825 227.115 304.665 229.343 305.252 231.797C305.838 234.252 304.887 223.701 304.887 223.701L300.83 227.12L300.825 227.115Z",
    fill: "#806869"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M194.954 204.799L164.895 254.62H170.339V319.258H224.014V246.552L201.608 209.57L194.954 204.799Z",
    fill: "#D1D3D4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M270.095 168.148C272.181 161.059 274.678 154.088 277.572 147.292C279.208 143.457 281.024 140.307 284.983 138.993C287.971 137.981 291.381 139.045 293.793 141.078C295.604 142.606 295.519 142.109 296.564 144.247L287.702 168.034L293.925 168.171L299 212.517L258.381 204.269L270.09 168.148H270.095Z",
    fill: "#70B14B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M590.896 167.547H358.033V319.234H590.896V167.547Z",
    fill: "#E6E7E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M287.323 168.171L287.702 168.034L320.531 79.6798L353.101 168.034H358.034L358.227 319.258H287.323V168.171Z",
    fill: "#D1D3D4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M240.207 205.536C240.524 204.042 240.869 202.557 241.228 201.086C243.664 191.197 246.899 181.503 250.89 172.134C252.526 168.294 254.342 165.149 258.301 163.835C261.289 162.823 264.699 163.887 267.111 165.92C269.523 167.954 271.079 170.824 272.256 173.752C274.403 179.105 275.453 184.827 276.451 190.512C277.359 195.69 278.234 200.873 279.076 206.066L240.202 205.531L240.207 205.536Z",
    fill: "#7BC253"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M409.217 227.286H457.241V184.761H409.217V227.286Z",
    fill: "#333333"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M409.217 297.324H457.241V254.8H409.217V297.324Z",
    fill: "#333333"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M422.269 253.939H420.945V298.185H422.269V253.939Z",
    fill: "#E5E5E4"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M407.354 252.284H459.105V299.835H407.354V252.284ZM455.799 255.589H410.659V296.529H455.799V255.589Z",
    fill: "#E5E5E4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M457.449 274.407H409.004V277.712H457.449V274.407Z",
    fill: "#E5E5E4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M434.882 253.939H431.576V299.584H434.882V253.939Z",
    fill: "#E5E5E4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M444.671 253.939H443.347V298.185H444.671V253.939Z",
    fill: "#E5E5E4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M407.354 181.385H459.105V228.936H407.354V181.385ZM455.799 184.695H410.659V225.635H455.799V184.695Z",
    fill: "#E5E5E4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M457.449 203.508H409.004V206.813H457.449V203.508Z",
    fill: "#E5E5E4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M434.882 183.04H431.576V228.685H434.882V183.04Z",
    fill: "#E5E5E4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M444.671 183.04H443.347V227.285H444.671V183.04Z",
    fill: "#E5E5E4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M422.269 183.04H420.945V227.285H422.269V183.04Z",
    fill: "#E5E5E4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M495.595 227.286H543.619V184.761H495.595V227.286Z",
    fill: "#333333"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M495.595 297.324H543.619V254.8H495.595V297.324Z",
    fill: "#333333"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M508.647 253.939H507.323V298.185H508.647V253.939Z",
    fill: "#E5E5E4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M493.731 252.284H545.482V299.835H493.731V252.284ZM542.177 255.589H497.037V296.529H542.177V255.589Z",
    fill: "#E5E5E4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M543.827 274.407H495.382V277.712H543.827V274.407Z",
    fill: "#E5E5E4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M521.26 253.939H517.954V299.584H521.26V253.939Z",
    fill: "#E5E5E4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M531.049 253.939H529.725V298.185H531.049V253.939Z",
    fill: "#E5E5E4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M493.731 181.385H545.482V228.936H493.731V181.385ZM542.177 184.695H497.037V225.635H542.177V184.695Z",
    fill: "#E5E5E4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M543.827 203.508H495.382V206.813H543.827V203.508Z",
    fill: "#E5E5E4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M521.26 183.04H517.954V228.685H521.26V183.04Z",
    fill: "#E5E5E4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M531.049 183.04H529.725V227.285H531.049V183.04Z",
    fill: "#E5E5E4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M508.647 183.04H507.323V227.285H508.647V183.04Z",
    fill: "#E5E5E4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M358.227 319.258H224.014V246.552L351.086 249.654L358.071 254.62L358.227 319.258Z",
    fill: "#E6E7E8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M358.033 173.856L590.891 168.772V167.547H358.033V173.856Z",
    fill: "#A7A9AC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M353.101 168.034H597.304L563.264 79.6798H320.531L353.101 168.034Z",
    fill: "#0098ED"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M334.118 89.7294H441.796L470.048 161.513V163.003H360.223L332.785 89.7294V86.2015L334.118 89.7294Z",
    fill: "#141E27"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M441.035 86.2015L470.048 161.513H361.24L332.785 86.2015H441.035Z",
    fill: "#191919"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M459.1 160.629L459.852 160.241L431.713 87.086L430.961 87.4737L459.1 160.629Z",
    fill: "#4D4E4E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M450.223 160.629L450.975 160.241L422.884 87.086L422.132 87.4737L450.223 160.629Z",
    fill: "#4D4E4E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M440.845 160.823L442.86 160.052L414.812 86.8968L412.802 87.6677L440.845 160.823Z",
    fill: "#4D4E4E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M432.475 160.629L433.227 160.241L405.226 87.086L404.474 87.4737L432.475 160.629Z",
    fill: "#4D4E4E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M423.603 160.629L424.355 160.241L396.396 87.086L395.644 87.4737L423.603 160.629Z",
    fill: "#4D4E4E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M414.225 160.818L416.235 160.052L388.324 86.8968L386.314 87.663L414.225 160.818Z",
    fill: "#4D4E4E"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M405.854 160.629L406.606 160.246L378.738 87.0908L377.986 87.4739L405.854 160.629Z",
    fill: "#4D4E4E"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M396.978 160.629L397.73 160.246L369.908 87.0908L369.156 87.4739L396.978 160.629Z",
    fill: "#4D4E4E"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M387.6 160.818L389.615 160.052L361.836 86.8968L359.826 87.663L387.6 160.818Z",
    fill: "#4D4E4E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M379.23 160.624L379.981 160.246L352.25 87.0908L351.498 87.4739L379.23 160.624Z",
    fill: "#4D4E4E"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M370.353 160.624L371.11 160.246L343.42 87.0908L342.669 87.4692L370.353 160.624Z",
    fill: "#4D4E4E"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M444.946 99.0791H339.056V99.902H444.946V99.0791Z",
    fill: "#4D4E4E"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M449.694 111.394H343.596V112.217H449.694V111.394Z",
    fill: "#4D4E4E"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M454.432 122.909H348.131V125.066H454.432V122.909Z",
    fill: "#4D4E4E"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M459.176 136.013H352.671V136.836H459.176V136.013Z",
    fill: "#4D4E4E"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M463.924 148.324H357.211V149.147H463.924V148.324Z",
    fill: "#4D4E4E"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M361.24 161.513L332.785 86.2064H441.035L470.048 161.518H468.478H361.24V161.513ZM335.901 88.3581L362.73 159.357H466.908L439.554 88.3581H335.901Z",
    fill: "#4D4E4E"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M452.309 89.7294H559.986L588.238 161.513V163.003H478.413L450.975 89.7294V86.2015L452.309 89.7294Z",
    fill: "#141E27"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M559.225 86.2015L588.238 161.513H479.43L450.975 86.2015H559.225Z",
    fill: "#191919"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M577.29 160.629L578.042 160.241L549.904 87.086L549.152 87.4737L577.29 160.629Z",
    fill: "#4D4E4E"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M568.419 160.629L569.17 160.241L541.075 87.086L540.323 87.4737L568.419 160.629Z",
    fill: "#4D4E4E"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M559.041 160.823L561.05 160.052L533.002 86.8968L530.992 87.6677L559.041 160.823Z",
    fill: "#4D4E4E"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M550.67 160.629L551.417 160.241L523.416 87.086L522.664 87.4737L550.67 160.629Z",
    fill: "#4D4E4E"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M541.793 160.629L542.545 160.241L514.587 87.086L513.835 87.4737L541.793 160.629Z",
    fill: "#4D4E4E"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M532.416 160.818L534.43 160.052L506.519 86.8968L504.504 87.663L532.416 160.818Z",
    fill: "#4D4E4E"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M524.045 160.629L524.797 160.246L496.928 87.0908L496.176 87.4739L524.045 160.629Z",
    fill: "#4D4E4E"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M515.168 160.629L515.92 160.246L488.099 87.0908L487.347 87.4739L515.168 160.629Z",
    fill: "#4D4E4E"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M505.79 160.818L507.805 160.052L480.031 86.8968L478.016 87.663L505.79 160.818Z",
    fill: "#4D4E4E"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M497.42 160.624L498.172 160.246L470.44 87.0908L469.688 87.4739L497.42 160.624Z",
    fill: "#4D4E4E"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M488.548 160.624L489.3 160.246L461.611 87.0908L460.859 87.4692L488.548 160.624Z",
    fill: "#4D4E4E"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M563.141 99.0791H457.251V99.902H563.141V99.0791Z",
    fill: "#4D4E4E"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M567.884 111.394H461.786V112.217H567.884V111.394Z",
    fill: "#4D4E4E"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M572.627 122.909H466.326V125.066H572.627V122.909Z",
    fill: "#4D4E4E"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M577.366 136.013H470.861V136.836H577.366V136.013Z",
    fill: "#4D4E4E"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M582.114 148.324H475.401V149.147H582.114V148.324Z",
    fill: "#4D4E4E"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M479.43 161.513L450.975 86.2064H559.225L588.238 161.518H586.668H479.43V161.513ZM454.092 88.3581L480.92 159.357H585.098L557.745 88.3581H454.092Z",
    fill: "#4D4E4E"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M221.026 254.62L194.954 204.799H332.004L358.071 254.62H224.407H221.026Z",
    fill: "#0098ED"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M333.939 268.131H320.125V269.517H333.939V268.131Z",
    fill: "#141E27"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M314.516 268.131H300.702V269.517H314.516V268.131Z",
    fill: "#141E27"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M295.089 268.131H281.275V269.517H295.089V268.131Z",
    fill: "#141E27"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M336.592 269.602H317.268V319.253H336.592V269.602Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M317.268 269.602H297.945V319.253H317.268V269.602Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M298.635 269.602H297.25V319.253H298.635V269.602Z",
    fill: "#9692A7"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M317.963 269.602H316.578V319.253H317.963V269.602Z",
    fill: "#CBCACA"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M297.945 269.602H278.622V319.253H297.945V269.602Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M279.312 269.602H277.927V319.253H279.312V269.602Z",
    fill: "#CBCACA"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M298.635 269.602H297.25V319.253H298.635V269.602Z",
    fill: "#CBCACA"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M333.939 275.339H320.125V314.207H333.939V275.339Z",
    fill: "#FFF200"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M314.516 275.339H300.702V314.207H314.516V275.339Z",
    fill: "#FFF200"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M295.089 275.339H281.275V314.207H295.089V275.339Z",
    fill: "#FFF200"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M355.919 276.213H336.596V319.253H355.919V276.213Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M341.098 294.771H338.791V302.455H341.098V294.771Z",
    fill: "#141E27"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M348.49 284.168L343.983 290.557H347.336L348.49 284.168Z",
    fill: "#141E27"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M345.501 295.48L350.008 289.091H346.655L345.501 295.48Z",
    fill: "#141E27"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M277.704 269.602H274.437V319.253H277.704V269.602Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M338.043 276.213H336.658V319.253H338.043V276.213Z",
    fill: "#CBCACA"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M177.995 201.673C180.984 200.66 184.394 201.725 186.806 203.758C189.217 205.792 190.773 208.662 191.951 211.59C194.098 216.943 195.148 222.665 196.146 228.35C197.602 236.64 198.969 244.949 200.255 253.267C200.955 257.793 201.631 262.343 201.608 266.925C201.594 270.269 201.196 273.626 200.199 276.814C197.56 285.26 189.771 292.448 180.923 292.392C175.995 292.358 171.214 290.126 167.62 286.754C164.025 283.378 161.557 278.928 160.034 274.241C156.35 262.891 158.071 250.51 160.923 238.924C163.359 229.035 166.593 219.341 170.585 209.972C172.221 206.137 174.037 202.987 177.995 201.673Z",
    fill: "#7BC253"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M187.241 235.656C184.157 239.567 182.857 244.731 182.375 249.616C181.812 255.249 182.029 260.952 182.039 266.603C182.048 272.326 182.062 278.053 182.077 283.775C182.091 289.232 182.1 294.69 182.114 300.147C182.129 306.078 182.138 312.003 182.152 317.934C182.152 317.144 182.152 318.719 182.152 317.934C182.152 319.414 179.859 319.418 179.849 317.934C179.84 315.711 179.825 315.848 179.816 313.625L179.745 298.842C179.721 293.749 179.698 288.655 179.669 283.557C179.655 280.833 179.632 278.109 179.632 275.39C179.632 274.279 179.66 273.168 179.603 272.056C179.49 269.758 179.187 267.578 178.672 265.327C177.645 260.824 175.872 256.568 173.38 252.681C172.779 251.745 172.136 250.837 171.46 249.952C171.081 249.46 171.384 248.666 171.871 248.377C172.462 248.032 173.068 248.297 173.446 248.789C179.168 256.266 182.166 265.7 181.935 275.097C181.878 277.348 181.954 279.604 181.963 281.855C181.987 286.802 182.01 291.753 182.034 296.7C182.058 301.817 182.086 306.934 182.11 312.05C182.119 313.866 182.129 315.682 182.138 317.498C182.138 318.388 182.181 316.922 182.152 317.806C182.152 317.848 182.152 317.886 182.152 317.929H179.849C179.84 311.847 179.825 308.13 179.811 302.048C179.797 296.529 179.788 291.011 179.773 285.492C179.759 279.774 179.745 274.061 179.736 268.344C179.731 265.218 179.717 262.087 179.717 258.961C179.717 256.28 179.745 253.598 179.953 250.926C180.355 245.649 181.419 240.239 184.361 235.746C184.749 235.155 185.169 234.587 185.609 234.029C185.992 233.542 186.834 233.627 187.236 234.029C187.718 234.512 187.624 235.169 187.236 235.656H187.241Z",
    fill: "#333333"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M224.014 259.33L358.071 255.514V254.62H224.014V259.33Z",
    fill: "#A7A9AC"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M178.794 120.208C187.477 120.208 194.76 125.032 196.784 131.549C198.364 130.825 200.184 130.409 202.119 130.409C207.212 130.409 211.492 133.261 212.721 137.129C216.944 137.38 220.25 139.64 220.25 142.393H212.461L212.452 142.412H150.888C151.758 138.345 155.522 135.148 160.275 134.452C160.762 126.517 168.868 120.208 178.799 120.208",
    fill: "#0098ED"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M111.456 137.096C94.8759 137.096 81.4405 123.656 81.4405 107.08C81.4405 90.4998 94.8807 77.0596 111.456 77.0596C128.037 77.0596 141.472 90.4998 141.472 107.08C141.472 123.661 128.032 137.096 111.456 137.096Z",
    fill: "#FFF100"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M109.39 163.419C109.39 159.81 113.698 156.845 119.198 156.519C120.801 151.449 126.381 147.708 133.012 147.708C135.537 147.708 137.906 148.252 139.963 149.203C142.598 140.662 152.089 134.334 163.401 134.334C176.34 134.334 186.9 142.61 187.539 153.01C193.734 153.923 198.638 158.113 199.768 163.447H119.548L119.538 163.419H109.39Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M111.456 129.269C99.118 129.269 89.1159 119.333 89.1159 107.075C89.1159 94.8175 99.118 84.8816 111.456 84.8816C123.795 84.8816 133.797 94.8175 133.797 107.075C133.797 119.333 123.795 129.269 111.456 129.269Z",
    fill: "#FFF000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeModalIllustrationUtilita);
export default __webpack_public_path__ + "static/media/welcome-modal-illustration-utilita.fb7fc4aa64f0bf2392dafa8b26e9b2c2.svg";
export { ForwardRef as ReactComponent };